import { Subject } from 'rxjs';
import { CoordinatorService } from './coordinator.service';
import { Pin } from './pin';

export type PIN_IMPORT = { id: string } | { tag: string; projectId: string };

export class Pin$ {
    private _pinMap = new Map<string, Pin>();
    private _misc: Pin | undefined;
    markForCheck$ = new Subject<void>();

    constructor(public coords: CoordinatorService) {
        this.clear();
    }

    get misc() {
        if (this._misc) return this._misc;
        const pId = this.coords.project$.currentId;
        if (!pId) return;
        return this.getOrCreate({
            tag: 'misc',
            projectId: pId,
        });
    }

    clear() {
        this._pinMap.clear();
    }

    private _tag2id(params: PIN_IMPORT) {
        return 'id' in params ? params.id : `${params.tag}_${params.projectId}`;
    }

    create(params: PIN_IMPORT) {
        const p = new Pin(this.coords, { id: this._tag2id(params) });
        this._pinMap.set(p.id, p);
        if (p.id.startsWith('misc_')) this._misc = p;
        return p;
    }

    getOrCreate(params: PIN_IMPORT) {
        const id = 'id' in params ? params.id : this._tag2id(params);
        let p = this._pinMap.get(id);
        if (p) return p;
        return this.create(params);
    }

    load3(ls: any[]) {
        ls.forEach((x) => {
            try {
                const p = this.getOrCreate({ id: x.id });
                p.update(x.tagLs);
            } catch (e) {
                this.coords.utils$.consoleError('PIN$ LOAD3 ERROR', e);
            }
        });
    }

    // async load2(muLs: ManifestUser[]) {
    //     const pLs = await muLs[0].pin()
    //     pLs?.forEach((x: any) => {
    //         const p = this.getOrCreate({ id: x.id })
    //         p.update(x.tagLs)
    //     })
    // }

    // manifestLoadResponse(params: any) {
    //     params.resultMap.forEach((x: any) => {
    //         const p = this.getOrCreate({ id: x.id })
    //         p.update(x.tagLs)
    //     })
    // }
}
